import React from 'react';
import ClassAssembly  from 'views/ClassAssembly12A';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;